import store from '@/store';

export default {
  canActivate(to, from, router) {
    return new Promise((resolve, reject) => {
      if (store.state.auth.token) {
        reject();
        router.push({ name: 'Home' });
      } else {
        resolve();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/guards/guest.js